import { CheckoutV1 } from '@getjust/api-schema';
import { is } from 'ramda';
import { useEffect } from 'react';

import { useBrandingPreviewAtom } from '$hooks/state/useBrandingPreviewAtom';

export const isAllowedOrigin = (origin: string) => {
  // Allow all origins in development for preview/testing
  if (process.env.NODE_ENV === 'development') return true;
  return /^https:\/\/[a-z0-9-]+\.getjust\.eu$/.test(origin);
};

export function useBrandingPreviewListener({ enabled }: { enabled: boolean }) {
  const { onBrandingPreviewChange } = useBrandingPreviewAtom();

  useEffect(() => {
    if (!enabled) return;
    const targetOrigin =
      process.env.NODE_ENV === 'development'
        ? '*'
        : document.referrer
          ? new URL(document.referrer).origin
          : undefined;
    if (!targetOrigin) return;
    window.parent.postMessage(
      JSON.stringify({
        emitter: 'JUST_FORM',
        type: 'BRANDING_PREVIEW_READY',
      }),
      targetOrigin,
    );
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;

    const messageHandler = (event: MessageEvent<any>) => {
      if (!isAllowedOrigin(event.origin)) return;

      const { data } = event;
      if (is(String, data) && data.includes('PARTNER_DASHBOARD')) {
        try {
          const parsed = JSON.parse(data);
          const result = CheckoutV1.ZBrandingPreviewMessage.safeParse(parsed);

          if (!result.success) return;

          onBrandingPreviewChange({
            checkoutTheme: result.data.checkoutTheme,
            brandStyles: result.data.brandStyles,
            logoUrl: result.data.logoUrl,
            backgroundUrl: result.data.backgroundUrl,
          });
        } catch (error) {
          console.error('Error while parsing branding preview message', error);
        }
      }
    };

    window.addEventListener('message', messageHandler, { capture: true });

    return () => window.removeEventListener('message', messageHandler, { capture: true });
  }, [enabled]); // eslint-disable-line react-hooks/exhaustive-deps
}
